import $ from 'jquery';
import _ from 'underscore';
import i18n, { t }  from '../../i18n/i18n.js';
import View from '../../../controls/View.js';
import MessagePopupView from '../../../controls/MessagePopupView.js';
import MainTabbedArea from '../../views/MainTabbedArea.js';
import ImportFromCampaignPopup from '../../popups/ImportFromCampaignPopup.js';
import app from '../../App.js';

var template =
    '<table class="user-mapping-table">' +
    '<thead>' +
    '<tr><th>{campaign_edit.user_mapping.mark_team_description}</th><th></th>' +
    '</thead>' +
    '<tbody></tbody>' +
    '</table>';

var CampaignEditUsersPage = View.extend({

    events: {
        'change input,select,textarea': 'onFieldChange'
    },

    initialize: function (options) {
        var that = this;

        that.options = options = options || {};

        var $cornerButtons = that.$cornerButtons = $('<div class="corner-buttons">').appendTo(that.$el);

        $('<button class="duplicate-button">').text(t('campaign_edit.import_from_campaign')).click(that.importFromCampaignClicked.bind(that)).appendTo($cornerButtons);

        var $scrollPane = that.$scrollPane = $('<div class="scrollable-pane-content has-bottom-corner-actions">').appendTo($('<div class="scrollable-pane">').appendTo(that.$el));

        $('<h2>').text(t('campaign_edit.user_mapping.title')).appendTo($scrollPane);

        $scrollPane.append(i18n.processLocalizedString(template));

        $('<div class="corner-commit-actions">').append(
            $('<button class="action-save-button">').text(t('save')).click(that.saveClicked.bind(that))
        ).appendTo(that.$el);

        that.$teamsTable = $scrollPane.find('table.user-mapping-table');

        that.ajaxGet(app.apiUrl('teams', { 'fields': 'id,name,users' }))
            .always(function () {
                app.AlertUI.hideLoader();
            })
            .then(function (teams) {

                var $tbody = that.$teamsTable.find('>tbody');

                teams.forEach(function (team) {

                    var $usersTableWrapper, $teamTitle, $chkTeam;

                    var $team = $('<tr>').append(
                        $('<td>').append(
                            $chkTeam = $('<input type="checkbox" />').attr('data-name', 'campaign-team-' + team['id']).data('id', team['id'])
                        ),
                        $('<td>').append(
                            $teamTitle = $('<div class="team-title open">').text(team['name']),
                            $usersTableWrapper = $('<div class="team-users">').attr('data-name', 'campaign-team-' + team['id'] + '-table-wrapper').append(
                                $('<table><tbody></tbody></table>')
                            )
                        )
                    );

                    $teamTitle.click(function () {
                        $usersTableWrapper.slideToggle({ duration: 150, easing: 'easeOutQuad' });
                        $teamTitle.toggleClass('open');
                    });

                    $chkTeam.change(function () {
                        $usersTableWrapper.find('input[type=checkbox]').prop('checked', this.checked);
                    });

                    var $usersTbody = $usersTableWrapper.find('tbody');
                    var userRows = team['users'].columnize(3, true);
                    userRows.forEach(function (usersRow) {
                        var $tr = $('<tr>');
                        usersRow.forEach(function (user) {
                            $('<td>').append(
                                $('<label>').append(
                                    $('<input type="checkbox" />').attr('data-name', 'campaign-user-' + user['id']).data('id', user['id']),
                                    $('<span>').text((user['first_name'] || '') + ' ' + (user['last_name'] || ''))
                                )
                            ).appendTo($tr);
                        });
                        $tr.appendTo($usersTbody);
                    });

                    $team.appendTo($tbody);

                });

                if (that._campaignData) {
                    that.loadFromData(that._campaignData);
                }
            })
            .fail(function (xhr, error) {
                app.showXhrError(xhr, error);
            });

        if (options.campaignId) {
            app.AlertUI.showLoader();
            that._isLoading = true;
            that.ajaxGet(app.apiUrl('campaigns/' + encodeURIComponent(options.campaignId)), { 'fields': 'id,name,project_id,teams,users' })
                .always(function () {
                    app.AlertUI.hideLoader();
                    that._isLoading = false;
                })
                .then(function (data) {

                    that._campaignData = data;
                    that.options.projectId = data['project_id'];

                    that.loadFromData(data);
                })
                .fail(function (xhr, error) {
                    app.showXhrError(xhr, error);
                });
        }
    },

    hasTitleAreaVisible: true,
    titleAreaContent: function () {
        return [
            $('<h2 class="title">').text(this._campaignData ? this._campaignData['name'] : '...'),
            $('<a class="back">').text('< ' + t('campaign_edit.back')).attr('href', '/admin/management/projects/' + this.options.projectId + '/campaigns')
        ];
    },

    loadFromData: function (data) {
        var that = this;

        if (app.getMainView() instanceof MainTabbedArea) {
            app.getMainView().refreshTitleArea();
        }

        // Clear checkboxes
        that.$teamsTable.find('input[type=checkbox]').prop('checked', false);

        // Check teams
        _.each(data['teams'], function (item) {
            that.$teamsTable.find('input[type=checkbox][data-name=campaign-team-' + item['id'] + ']').prop('checked', true);
        });

        // Check users
        _.each(data['users'], function (item) {
            that.$teamsTable.find('input[type=checkbox][data-name=campaign-user-' + item['id'] + ']').prop('checked', true);
        });

        return that;
    },

    render: function () {

        var that = this;

        return this;
    },

    saveClicked: function () {
        var that = this;

        that.$scrollPane.find('input.invalid,textarea.invalid,select.invalid').removeClass('invalid');

        var invalid = false;

        var data = {
        };

        var teamIds = [], userIds = [];
        that.$teamsTable.find('input[type=checkbox][data-name^=campaign-team]').each(function () {
            if (!this.checked) return;
            teamIds.push($(this).data('id'));
        });
        that.$teamsTable.find('input[type=checkbox][data-name^=campaign-user]').each(function () {
            if (!this.checked) return;
            userIds.push($(this).data('id'));
        });

        data['team_ids'] = teamIds;
        data['user_ids'] = userIds;

        if (invalid) {
            that.$scrollPane.find('input.invalid,textarea.invalid,select.invalid').first().focus();
            return;
        }

        var apiUrl = app.apiUrl('campaigns/' + encodeURIComponent(that.options.campaignId));

        app.AlertUI.showLoader(t('activity_indicator.saving'));

        that.ajaxJsonPost(apiUrl, data)
            .always(function () {
                app.AlertUI.hideLoader();
            })
            .then(function (response) {
                that._saveNeeded = false;

                new MessagePopupView({addClass: 'done', message: t('campaign_edit.call_settings.saved_prompt'), queue: true}).show();
            })
            .fail(function (xhr, error) {
                app.showXhrError(xhr, error);
            });

        return that;
    },

    onFieldChange: function () {
        this._saveNeeded = true;
        return this;
    },

    importFromCampaignClicked: function () {
        var that = this;

        if (that._isLoading) return that;

        if (that._importPopup) {
            that._importPopup.remove();
        }

        var popup = that._importPopup = new ImportFromCampaignPopup({ projectId: that.options.projectId });
        that.listenTo(popup, 'select', function (item) {

            that._isLoading = true;
            that.ajaxGet(app.apiUrl('campaigns/' + encodeURIComponent(item['id'])), { 'fields': 'id,name,teams,users' })
                .always(function () {
                    that._isLoading = false;
                })
                .then(function (data) {
                    that.loadFromData(data);
                    popup.hide();
                })
                .fail(function (xhr, error) {
                    app.showXhrError(xhr, error);
                });

        });

        that._importPopup.show();

        return that;
    },

    hasUnsavedChanges: function() {
        return this._saveNeeded;
    },

    remove: function () {
        var that = this;

        if (that._importPopup) {
            that._importPopup.remove();
        }

        CampaignEditUsersPage.__super__.remove.apply(this, arguments);
    }

});

export default CampaignEditUsersPage;
